<template>
  <v-container
    class="pa-0 flex-grow-0 filter-container"
    fluid
  >
    <slot name="table-actions">
      <w-row class="filter-container_row">
        <w-column
          cols="auto"
        >
          <w-icon-button 
            v-if="showBulkSelectAction"
            icon="$wBulkExecuteSelection"
            @click="$emit('bulkSelectionTriggered')"
          >
            <template #tooltip>
              {{ $t('Components.sentences.acceptAllDeviations') }}
            </template>
          </w-icon-button>
        </w-column>
        <w-column
          v-if="allowAdd"
          cols="auto"
        >
          <w-add-button
            v-show="enableCreateNewData"
            @click="$emit('new:clicked')"
          >
            <template #tooltip>
              {{ $t('Components.sentences.createNewDataSet') }}
            </template>
          </w-add-button>
        </w-column>
        <w-column
          v-if="allowZipDownload"
          cols="auto"
        >
          <w-download-zip-button @click="$emit('zip-export:clicked')" />
        </w-column>
        <w-column
          v-if="allowCsvDownload"
          cols="auto"
        >
          <w-download-csv-button @click="$emit('csv-export:clicked')" />
        </w-column>
        <w-column
          v-if="allowDownload"
          cols="auto"
        >
          <w-download-excel-button @click="$emit('export:clicked')">
            <template #tooltip>
              {{ $t('Common.download') }}
            </template>
          </w-download-excel-button>
        </w-column>
        <v-spacer />
        <!--          <w-column cols="auto" v-if="isFilterable">-->
        <!--            <w-clear-filters-button @click="clearFilters($route)" />-->
        <!--          </w-column>-->
        <slot name="inner-table-actions" />
        <w-column
          v-show="allowChangeTableHeaders"
          cols="auto"
        >
          <WorkHeaderPicker
            :headers="headers"
            :orderd-headers="orderdHeaders"
            :not-visible-headers="notVisibleHeaders"
            :truncate-data="truncateData"
            :truncate-options="truncateOptions"
            :allow-column-mode-switch="allowColumnModeSwitch"
            @update:truncate-data="$emit('update:truncate-data', $event)"
            @update:truncate-options="$emit('update:truncate-options', $event)"
            @update:not-visible-headers="
              (newNotVisibleHeaders) =>
                $emit('update:not-visible-headers', newNotVisibleHeaders)
            "
            @update:orderd-headers="
              (newHeaderOrder) => $emit('update:orderd-headers', newHeaderOrder)
            "
          />
        </w-column>
      </w-row>
    </slot>
  </v-container>
</template>

<script>
export default {
  name: 'BaseLevelTableHeaderContainer',
  components: {
    WorkHeaderPicker: () =>
      import('@/components/global_components/tables/WorkHeaderPicker'),
  },

  props: {
    // feature flags
    allowRedirectToSearch: { type: Boolean, required: true },
    allowAdd: { type: Boolean, required: true },
    allowChangeTableHeaders: { type: Boolean, required: true },
    allowColumnModeSwitch: { type: Boolean, required: true },
    allowDownload: { type: Boolean, required: true },
    allowZipDownload: { type: Boolean, required: true },
    allowCsvDownload: { type: Boolean, required: true },
    // data
    headers: { type: Array, required: false },
    orderdHeaders: { type: Array, required: false },
    notVisibleHeaders: { type: Array, required: false },
    preset: { type: Object, required: true },
    truncateData: { type: Boolean, required: true },
    truncateOptions: { type: Object, required: true },
    enableCreateNewData: { type: Boolean, default: true },
    showBulkSelectAction: { type: Boolean, default: false }
  },
};
</script>

<style lang="scss" scoped>
.filter-container .filter-container_row .col {
  padding-left: $spacer;
  padding-right: $spacer;
}
</style>
